<!-- Fiche guide d'une culture (P3.5.1, P3.1.7.2, P2.3) sur le gabarit de la fiche plante :
     titre aux jetons, famille en sous-titre, photo en vignette ; sections en cartes
     bordées ; une section sans contenu ne s'affiche pas. -->
<div class="flex h-full flex-col bg-vw-bg">
  <header class="flex items-center gap-3 border-b border-vw-line bg-vw-surface px-4 pb-3"
    [ngClass]="inSheet ? 'pr-14 pt-6' : 'pt-4'" data-test="guide-header">
    <div class="min-w-0 flex-1">
      <h1 class="break-words font-display text-title-l text-vw-ink">{{ cultivationVariant?.name }}</h1>
      @if (getFamily(); as family) {
        <p class="text-body-s text-vw-muted">{{ family }}</p>
      }
    </div>
    <span class="flex h-16 w-16 shrink-0 items-center justify-center overflow-hidden rounded-field bg-vw-surface-sunk"
      [style.background-color]="cultivationVariant?.backgroundColor ? (cultivationVariant.backgroundColor | HexToHsl) : null">
      <vw-icon-svg [iconUrl]="photoUrl" fallback="plant"
        additionalClasses="h-16 w-16 object-cover" width="64px" height="64px"></vw-icon-svg>
    </span>
  </header>
  <div class="flex flex-1 flex-col gap-4 overflow-auto p-4">
    <!-- Même bouton que la fiche plante et la fiche sachet. -->
    <vw-button look="secondary" label="garden.buySeeds" customClass="w-full" (onClick)="onBuySeeds()"></vw-button>

    @if (cultivationVariant?.description || cultivation?.description) {
      <section class="rounded-card border border-vw-line bg-vw-surface p-4">
        <h2 class="mb-2 text-title-s text-vw-ink">{{ 'garden.guide.description' | translate }}</h2>
        <p class="select-text text-body text-vw-body" [innerHTML]="cultivationVariant?.description || cultivation?.description"></p>
      </section>
    }

    <section class="rounded-card border border-vw-line bg-vw-surface p-4">
      <h2 class="mb-2 text-title-s text-vw-ink">{{ 'garden.guide.needs' | translate }}</h2>
      <vw-needs [needs]="cultivationVariant?.needs || cultivation?.needs"></vw-needs>
    </section>

    <!-- Les quatre natures de période, chacune avec son mot (PC-11). -->
    <section class="rounded-card border border-vw-line bg-vw-surface p-4">
      <h2 class="mb-2 text-title-s text-vw-ink">{{ 'garden.guide.periods.title' | translate }}</h2>
      <div class="flex w-full flex-col gap-3">
        <vw-calendar-period-line [periods]="periods" [showMonths]="true"></vw-calendar-period-line>
        <vw-calendar-period-legend [kinds]="periodKinds"></vw-calendar-period-legend>
      </div>
    </section>

    <!-- Cohabitation : les amies, puis celles à éloigner ; rien à dire, pas de carte. -->
    @if (relations.length) {
      <section class="flex flex-col gap-3 rounded-card border border-vw-line bg-vw-surface p-4" data-test="guide-associations">
        <h2 class="text-title-s text-vw-ink">{{ 'garden.guide.associations' | translate }}</h2>
        @if (friends.length) {
          <div class="flex flex-col gap-2">
            <p class="text-body-s font-semibold text-vw-body">{{ 'garden.guide.friends' | translate }}</p>
            <div class="flex flex-wrap gap-2">
              @for (relation of friends; track relation.name) {
                <span class="flex min-h-9 items-center gap-1 rounded-pill bg-vw-surface-tint px-3 text-body-s font-semibold text-vw-primary-ink" data-test="guide-friend">
                  <vw-check-icon class="block h-4 w-4 [&>svg]:h-full [&>svg]:w-full" />
                  {{ relation.name }}
                </span>
              }
            </div>
          </div>
        }
        @if (enemies.length) {
          <div class="flex flex-col gap-2">
            <p class="text-body-s font-semibold text-vw-body">{{ 'garden.guide.enemies' | translate }}</p>
            <div class="flex flex-wrap gap-2">
              @for (relation of enemies; track relation.name) {
                <span class="flex min-h-9 items-center gap-1 rounded-pill border border-vw-line bg-vw-surface px-3 text-body-s font-semibold text-vw-danger" data-test="guide-enemy">
                  <vw-close-icon class="block h-4 w-4" />
                  {{ relation.name }}
                </span>
              }
            </div>
          </div>
        }
      </section>
    }

    <!-- Risques : la carte n'apparaît que s'il y a un risque à dire. -->
    @if (risks.length) {
      <section class="flex flex-col gap-2 rounded-card border border-vw-line bg-vw-surface p-4" data-test="guide-risks">
        <h2 class="text-title-s text-vw-ink">{{ 'garden.guide.risks' | translate }}</h2>
        @for (risk of risks; track risk) {
          <div class="flex min-h-target items-center justify-between gap-2 rounded-field border border-vw-line px-3 text-body font-semibold text-vw-ink">
            {{ risk.name }}
            <vw-icon-svg [iconUrl]="risk.iconUrl" additionalClasses="rotate-180" width="20"></vw-icon-svg>
          </div>
        }
      </section>
    }
  </div>
</div>
